import type RpcDataSort     from '@/core/services/Rpc/RpcDataSort';
import type PriorityOption  from '@/domains/SWPortalTask/PriorityOption';
import Core                 from '@/core/Core';
import BaseService          from '@/core/services/BaseService';
import SWPortalEmployeesDAO from '@/domains/SWPortalTask/SWPortalEmployeesDAO';
import SWPortalTasksDAO     from '@/domains/SWPortalTask/SWPortalTasksDAO';
import Dictionary           from '@/core/types/Dictionary';
import RpcDataPagination    from '@/core/services/Rpc/RpcDataPagination';

class SWPortalTasksService extends BaseService {

    /**
     * Кеш опций приоритета. Наполняется из Dictionaries общим эндпоинтом.
     * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
     */
    static priorityOptions = reactive(new Dictionary<string, PriorityOption>());

    static get dao() {
        return SWPortalTasksDAO;
    }

    static getReceivers() {
        return [
            { id: 544,  name: 'Гаврилов Владислав Иванович', departmentId: '199', departmentName: 'Транспортный отдел' },
            { id: 3092, name: 'Новиков Игорь Владимирович',  departmentId: '199', departmentName: 'Транспортный отдел' },
            { id: 7696, name: 'Мирная Оксана Валерьевна',    departmentId: '199', departmentName: 'Транспортный отдел', email: 'mirnaya.ov@sibvaleo.com' },
        ];
    }

    /** получаем исполнителей для слайдера */
    static getPerformers(isMoscowSellers: boolean) {
        if (isMoscowSellers) {
            return [
                // { id: 3833, name: 'Шмелева Галина Ивановна', departmentId: '205', departmentName: 'РЦ Москва' },
                { id: 6357, name: 'Гаврилова Елена Геннадьевна', departmentId: '216', departmentName: 'Отдел контроля качества (ОКК на РЦ)', email: 'gavrilova.eg@sibvaleo.com' },
                { id: 4306, name: 'Ризакулиева Амина Мурадовна', departmentId: '205', departmentName: 'РЦ Москва' },
                { id: 8568, name: 'Боков Евгений Алексеевич' },
            ];
        }

        return [
            { id: 544, name: 'Гаврилов Владислав Иванович', departmentId: '199', departmentName: 'Транспортный отдел' },
        ];
    }

    /** получаем наблюдателей для слайдера */
    static getWatchers(isMoscowSellers: boolean) {
        const permanentWatchers = [
            { id: 3092, name: 'Новиков Игорь Владимирович', departmentId: '199', departmentName: 'Транспортный отдел' },
            { id: 7696, name: 'Мирная Оксана Валерьевна',   departmentId: '199', departmentName: 'Транспортный отдел', email: 'mirnaya.ov@sibvaleo.com' },
        ];

        if (isMoscowSellers) {
            return [
                { id: 1543, name: 'Холоденина Ольга Николаевна', departmentId: '205', departmentName: 'РЦ Москва' },
                { id: 544,  name: 'Гаврилов Владислав Иванович', departmentId: '199', departmentName: 'Транспортный отдел' },
            ].concat(permanentWatchers);
        }

        return permanentWatchers;
    }

    static async create(task: any): Promise<boolean> {
        task.transportOrder = { id: task.transportOrder.id };

        const response = await this.dao.add(task);

        if (response.ok) {
            Core.showNotification.success('Задача успешно создана');
        }

        return response.ok;
    }

    static async getListEmployees(pattern: string) {
        const response = await SWPortalEmployeesDAO.getList({ pattern });

        return response.data;
    }

    static async getListEmployeesPaginated(
        params?: Parameters<typeof SWPortalEmployeesDAO.getList>[0] & {
            pagination?: RpcDataPagination;
            sort?: RpcDataSort;
        }
    ) {
        const { pagination, sort, ...filters } = params ?? {};
        const response = await SWPortalEmployeesDAO.getList(filters, pagination, sort);

        return {
            data:       response.data,
            pagination: response.meta.pagination,
        };
    }

    static async searchEmployees(pattern?: string) {
        if (!pattern || pattern.length === 0) {
            return [];
        }

        const result = await SWPortalTasksService.getListEmployeesPaginated({
            pattern,
            pagination: RpcDataPagination.createForSearch(),
        });

        return result.data;
    }
}

export default SWPortalTasksService;